<template>
  <img
    v-if="topShow"
    src="@/static/img/returntop.png"
    class="back-top"
    @click.stop="backTop">
</template>

<script>
export default {
  data () {
    return {
      topShow: false,
      timer: null
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleTop)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleTop)
  },
  methods: {
    // 监听页面滚动距离
    handleTop () {
      var scrollY =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollY > 600) {
        this.topShow = true
      } else {
        this.topShow = false
      }
    },
    // 过渡返回顶部
    backTop () {
      clearTimeout(this.timer)
      cancelAnimationFrame(this.timer)
      const fn = () => {
        const scrollY = window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
        if (scrollY > 0) {
          // 消除突然返回顶部的突兀感
          document.documentElement.scrollTop = scrollY - scrollY / 5
          requestAnimationFrame(fn) || setTimeout(fn, 1000 / 60)
        } else {
          cancelAnimationFrame(this.timer) || clearTimeout(this.timer)
        }
      }
      this.timer = requestAnimationFrame(fn) || setTimeout(fn, 1000 / 60)
    }
  }
}
</script>

<style lang="stylus" scoped>
.back-top
  position fixed
  cursor pointer
  bottom 40px
  right 40px
  width 60px
  height 60px
  border-radius 50%
  font-size 20px
</style>
